import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { CacheService, Entity } from "mapfre-auditlib";
import moment from 'moment';
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../../../environments/environment";

@Injectable({
   providedIn: "root"
})
export class EntityService {

   className = 'EntityService'

   memoryCache: any = {
      "entitiesBySO": {
         "data": null,
         "lastReqDate": null
      },
      "entitiesByCountryId": {
         "data": null,
         "lastReqDate": null
      }
   }

   sections = [
      'administration',
      'works/dashboard',
      'recommendations/dashboard',
      'following',
      'dashboard/budget'
   ]

   constructor(private http: HttpClient, private router: Router, private cacheService: CacheService) { }

   getAllEntities(showAll = false, cache = true): Observable<Entity[]> | any{
      let params: any = {};
      params.showAll = showAll;
      const isSection = _.some(this.sections, section => _.includes(this.router.url, section));
      let cacheKey = "allEntities"+"_"+showAll.toString()+"_"+isSection.toString()

      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
      } else {
         let observable = this.http.get<Entity[]>(environment.base_URL + "/entities", { params }).pipe(map((res) => {
            if(isSection){
               this.cacheService.updateCacheData(res, cacheKey)
               return res;
            }else{
               let filtrado =  _.filter(res, it => it.mrkActive);
               this.cacheService.updateCacheData(filtrado, cacheKey)
               return filtrado;
            }
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
      }
   }

   getEntitiesByBusinessUnit(unitBusinessID: number, showAll: boolean = false): Observable<Entity[]> {
      let params: any = {};
      params.showAll = showAll;
      params.unitBusiness = unitBusinessID;
      return this.http.get<Entity[]>(environment.base_URL + '/entities', { params });
   }

   getEntitiesBySO(id, cache = true): Observable<Entity[]> | any {
      const isSection = _.some(this.sections, section => _.includes(this.router.url, section));
      let cacheKey = "entitiesBySO"+"_"+isSection.toString()

      if (cache && this.cacheService.canUseCache(cacheKey, [id.toString()])) {
         return this.cacheService.getCacheData(cacheKey, [id.toString()]);
      } else {
         let observable = this.http.get<Entity[]>(environment.base_URL + `/entities/organizational/${id}`).pipe(map((res) => {
            if(isSection){
               this.cacheService.updateCacheData(res, cacheKey, [id.toString()])
               return res;
            }else{
               let filtrado =  _.filter(res, it => it.mrkActive);
               this.cacheService.updateCacheData(filtrado, cacheKey, [id.toString()])
               return filtrado;
            }
         }))
         this.cacheService.updateCacheReq(cacheKey, [id.toString()] );
         return observable;
      }
   }

   getEntitiesByCountriesId(countriesIds, cache = true): any {
      let params = {
         countriesIdsList: countriesIds.join(',')
      }
      const isSection = _.some(this.sections, section => _.includes(this.router.url, section));
      let cacheKey = "entitiesByCountryId"+"_"+isSection.toString()

      if (cache && this.cacheService.canUseCache(cacheKey, [countriesIds.toString()])) {
         return this.cacheService.getCacheData(cacheKey, [countriesIds.toString()]);
      } else {
         let observable = this.http.get<Entity[]>(environment.base_URL + "/entities", { params }).pipe(map((res) => {
            if(isSection){
               this.cacheService.updateCacheData(res, cacheKey, [countriesIds.toString()])
               return res;
            }else{
               let filtrado =  _.filter(res, it => it.mrkActive);
               this.cacheService.updateCacheData(filtrado, cacheKey, [countriesIds.toString()])
               return filtrado;
            }
         }))
         this.cacheService.updateCacheReq(cacheKey, [countriesIds.toString()] );
         return observable;
      }
   }   

   removeById(array) {
      array.forEach(element => {
         delete element.id;
      });
      return array;
   }

   newEntity(entity) {
      return this.http.post(environment.base_URL + "/entities", entity);
   }

   updateEntity(entity, id) {
      return this.http.put(environment.base_URL + `/entities/${id}`, entity);
   }

   deleteEntity(id: Number) {
      return this.http.delete(environment.base_URL + `/entities/${id}`);
   }

   canUseCache(key) {
      let oldDate = _.get(this.memoryCache, `${key}.lastReqDate`);
      let canUse = false;
      if (moment().diff(oldDate, 'minutes') <= 1) {
         canUse = true;
      }
      return canUse;
   }

   updateCacheData(data, key) {
      _.set(this.memoryCache, `${key}.data`, data);

      _.get(this.memoryCache, `${key}._subject`).next(data);
   }

   updateCacheReq(key) {
      let _subject = new Subject<any>();
      let observer = _subject.asObservable();
      _.set(this.memoryCache, key, { observer, _subject, lastReqDate: moment() });
   }


}
